"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tabsComponent = exports.TabsComponent = void 0;
const app_1 = require("app");
const SCROLL_DESKTOP_GUTTER = 48;
const SCROLL_MOBILE_GUTTER = 32;
// Allow initial layout, sticky header, and content measurements to settle before selecting a tab.
const INITIAL_TAB_SELECTION_DELAY = 600;
var ScrollDirection;
(function (ScrollDirection) {
    ScrollDirection["Down"] = "down";
    ScrollDirection["Up"] = "up";
})(ScrollDirection || (ScrollDirection = {}));
class TabsComponent extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.tabs-control';
        this.headerClass = '.header';
        this.stickyTabsClass = '.sticky-tabs';
        this.tabsListClass = '.tabs-list';
        this.tabsItem = '.tabs__item';
        this.tabsListWrapperClass = '.tabs-list-wrapper';
        this.tabsItemLinkClass = '.tabs__item-link';
        this.tabsArrowClass = '.tabs__arrow';
        this.tabsContentClass = '.tabs-content';
        this.tabActiveClass = '!border-brand-primary bg-surface-primary !text-brand-primary';
        this.tabNonActiveTab = 'text-secondary disabled:text-disabled enabled:hover:text-primary enabled:hover:border-brand-primary border-[transparent] disabled:cursor-auto';
        this.tabsSelectedItemClass = '.tabs__selected-item';
        this.tabsSelectedItemTitleClass = '.tabs__selected-item-title';
        this.breadCrumbsClass = '.breadcrumbs';
        this.tabIdAttribute = 'data-tab-id';
        this.productPageClass = '.product-page';
        this.verticalGutter = SCROLL_DESKTOP_GUTTER;
        this.programScrolling = true;
        this.tabsCount = 0;
        this.lastPageYOffset = 0;
        this.isProductPage = false;
        this.initiated = false;
        this.tabsItemsClickHandler = (ev) => {
            var _a;
            const targetElement = ev.target.children;
            const targetTabElement = targetElement[0];
            this.makeActiveTab(targetTabElement);
            // Add GTM event only for Product Page
            if (this.isProductPage) {
                const targetTabId = (targetTabElement === null || targetTabElement === void 0 ? void 0 : targetTabElement.dataset.tabId)
                    ? targetTabElement === null || targetTabElement === void 0 ? void 0 : targetTabElement.dataset.tabId
                    : (_a = ev.target) === null || _a === void 0 ? void 0 : _a.dataset.tabId;
                app_1.GTM.productTabs(targetTabId);
            }
        };
        this.tabChangeHandler = (event) => {
            var _a;
            event.preventDefault();
            const target = event.currentTarget;
            const buttonChild = target.querySelector('button');
            const nextHash = (_a = buttonChild === null || buttonChild === void 0 ? void 0 : buttonChild.dataset.id) === null || _a === void 0 ? void 0 : _a.toLowerCase();
            if (nextHash) {
                this.updateHash(nextHash);
                this.updateArrowsState();
                this.highlightSelectedTab(nextHash, event.currentTarget);
                this.selectTab(nextHash);
            }
        };
        this.scrollTabsTitleIntoView = (tab) => {
            if (!tab || !this.tabsList) {
                return;
            }
            const HORIZONTAL_GUTTER = 15;
            // Calculate the tab's position relative to the scroll container
            const tabOffsetLeft = tab.offsetLeft;
            const tabWidth = tab.offsetWidth;
            const containerWidth = this.tabsList.clientWidth;
            const maxScrollLeft = this.tabsList.scrollWidth - containerWidth;
            // Center the tab in the container, but clamp to max scroll
            let scrollTo = tabOffsetLeft - containerWidth / 2 + tabWidth / 2 - HORIZONTAL_GUTTER;
            scrollTo = Math.max(0, Math.min(scrollTo, maxScrollLeft));
            app_1.scrollService.GoToPosition(app_1.ScrollDirectionEnum.Left, scrollTo, 250, this.tabsList, false);
        };
    }
    BeforeInit() {
        var _a;
        this.tabsElement = this.el[0];
        this.header = document.querySelector(this.headerClass);
        this.tabsList = this.tabsElement.querySelector(this.tabsListClass);
        this.tabsItems = this.tabsElement.querySelectorAll(this.tabsItem);
        this.tabsContent = document.querySelector(this.tabsContentClass);
        this.tabsListContainer = document.querySelector(this.stickyTabsClass);
        this.prevArrow = this.tabsElement.querySelector('.tabs__arrow--prev');
        this.nextArrow = this.tabsElement.querySelector('.tabs__arrow--next');
        this.tabsCount = ((_a = this.tabsList) === null || _a === void 0 ? void 0 : _a.children.length) || 0;
        this.isProductPage = !!document.querySelector(this.productPageClass);
    }
    OnInit() {
        this.setTabsStyleVariable(this.tabsElement);
        this.updateVerticalGutter();
        if (this.tabsCount > 1) {
            this.tabsItems.forEach((el) => {
                el.addEventListener('click', this.tabsItemsClickHandler);
                el.addEventListener('tab', this.tabsItemsClickHandler);
            });
            if (this.prevArrow) {
                this.prevArrow.addEventListener('click', () => this.scrollTabList(false));
            }
            if (this.nextArrow) {
                this.nextArrow.addEventListener('click', () => this.scrollTabList(true));
            }
            if (this.tabsList) {
                this.tabsList.addEventListener('scroll', (0, app_1.throttle)(() => {
                    this.updateArrowsState();
                }, 200));
            }
        }
        this.tabsItems.forEach((el) => {
            el.addEventListener('click', this.tabChangeHandler);
            el.addEventListener('tab', this.tabChangeHandler);
        });
        this.lastPageYOffset = globalThis.scrollY;
        this.initialTabSelection();
        document.addEventListener('anchor-link:click', event => {
            const { hash } = event.detail;
            this.scrollTabsByAnchorHashPosition(hash);
            this.highlightSelectedTab(hash);
        });
    }
    setTabsStyleVariable(tabsElement) {
        const tabsElementHeight = tabsElement.offsetHeight;
        document.body.style.setProperty('--tabs-height', `${tabsElementHeight}px`);
    }
    scrollTabsByAnchorHashPosition(hash) {
        var _a, _b;
        if (!hash)
            return;
        const targetElement = document.querySelector(hash);
        const tabButtonId = (_a = targetElement === null || targetElement === void 0 ? void 0 : targetElement.closest('[data-tab-id]')) === null || _a === void 0 ? void 0 : _a.dataset.tabId;
        const tabButton = (_b = this.tabsList) === null || _b === void 0 ? void 0 : _b.querySelector(`[data-id="#${tabButtonId}"]`);
        if (tabButton) {
            this.scrollTabsTitleIntoView(tabButton);
        }
    }
    makeActiveTab(activeElement) {
        this.tabsItems.forEach((element) => {
            var _a, _b;
            const button = element.querySelector('button');
            if (button) {
                (_a = button.classList) === null || _a === void 0 ? void 0 : _a.remove(...this.tabActiveClass.split(' '));
                (_b = button.classList) === null || _b === void 0 ? void 0 : _b.add(...this.tabNonActiveTab.split(' '));
            }
        });
        activeElement === null || activeElement === void 0 ? void 0 : activeElement.classList.remove(...this.tabNonActiveTab.split(' '));
        const closestButton = activeElement === null || activeElement === void 0 ? void 0 : activeElement.closest('button');
        if (closestButton) {
            closestButton === null || closestButton === void 0 ? void 0 : closestButton.classList.add(...this.tabActiveClass.split(' '));
        }
    }
    OnHashChange() {
        this.updateArrowsState();
        const hash = globalThis.location.hash.toLowerCase();
        this.highlightSelectedTab(hash);
        this.selectTab(hash);
    }
    OnWindowResizeThrottle() {
        this.updateVerticalGutter();
        this.updateArrowsState();
        this.updateTabs();
    }
    OnScrollThrottle() {
        /**
         * disable hash replace before init to save anchor's hash after page load,
         * use isBusy to prevent hash blinking on anchor click
         */
        if (!this.initiated || app_1.scrollService.isBusy || app_1.overlayService.isOverlayVisible) {
            return;
        }
        this.lastPageYOffset = globalThis.scrollY;
        this.updateTabs();
    }
    OnTouchStart() {
        this.lastPageYOffset = globalThis.scrollY;
    }
    updateTabs() {
        var _a, _b, _c;
        clearTimeout(this.scrollTimeout);
        this.scrollTimeout = setTimeout(() => {
            this.programScrolling = false;
        }, 100);
        if (this.programScrolling) {
            return;
        }
        const offset = this.getTabsListContainerHeight() + (((_a = this.header) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0) + this.verticalGutter;
        let currentTabHash;
        let previousTabHash;
        let closestTabHash = '';
        let minDistance = Infinity;
        let scrollDirection = globalThis.scrollY > this.lastPageYOffset ? ScrollDirection.Down : ScrollDirection.Up;
        const tabElements = (_b = this.tabsContent) === null || _b === void 0 ? void 0 : _b.querySelectorAll(`[${this.tabIdAttribute}]`);
        tabElements === null || tabElements === void 0 ? void 0 : tabElements.forEach((elem) => {
            const rect = elem.getBoundingClientRect();
            const { top, bottom } = rect;
            if (offset > top + 5 && offset < bottom - 5) {
                currentTabHash = `#${elem.getAttribute(this.tabIdAttribute)}`;
                previousTabHash = elem.classList.contains('hidden-tab')
                    ? `#${this.getPreviousVisibleTabId(elem)}`
                    : '';
            }
            // Calculate tab position and distance to prevent unnecessary tab jumping
            const tabHash = `#${elem.getAttribute(this.tabIdAttribute)}`;
            const distance = Math.abs(rect.top - offset);
            if ((scrollDirection === ScrollDirection.Down && rect.top >= offset) ||
                (scrollDirection === ScrollDirection.Up && rect.top <= offset)) {
                if (distance < minDistance) {
                    minDistance = distance;
                    closestTabHash = tabHash;
                }
            }
        });
        const globalThisHeight = globalThis.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        if (globalThis.scrollY + globalThisHeight > documentHeight - 10) {
            const selector = `[${this.tabIdAttribute}]`;
            const lastTab = (_c = this.tabsContent) === null || _c === void 0 ? void 0 : _c.querySelector(`${selector}:last-of-type`);
            if (lastTab) {
                currentTabHash = `#${lastTab.getAttribute(this.tabIdAttribute)}`;
            }
        }
        // Fallback to currentTabHash if no closer found in direction
        if (minDistance === Infinity && currentTabHash) {
            closestTabHash = currentTabHash;
        }
        currentTabHash = closestTabHash;
        if (currentTabHash && currentTabHash !== globalThis.location.hash.toLowerCase()) {
            this.replaceHash(currentTabHash);
            this.updateArrowsState();
            this.highlightSelectedTab(previousTabHash || currentTabHash);
        }
    }
    selectTab(id) {
        var _a;
        this.programScrolling = true;
        const tabId = id.substring(1);
        if (!tabId) {
            this.programScrolling = false;
            return;
        }
        const tabToSelect = (_a = this.tabsContent) === null || _a === void 0 ? void 0 : _a.querySelector(`[${this.tabIdAttribute}="${tabId}"]`);
        if (!tabToSelect) {
            return;
        }
        if (tabToSelect.classList.contains('hidden-tab')) {
            this.highlightSelectedTab(`#${this.getPreviousVisibleTabId(tabToSelect)}`);
        }
        app_1.scrollService.GoToElement(tabToSelect, 0, false);
    }
    highlightSelectedTab(hash, target) {
        this.deactivateAllTabs();
        const tab = this.findTabToActivate(hash, target);
        this.activateTab(tab);
    }
    deactivateAllTabs() {
        this.tabsItems.forEach((item) => {
            const button = item.querySelector('button');
            if (button) {
                button.classList.remove(...this.tabActiveClass.split(' '));
                button.classList.add(...this.tabNonActiveTab.split(' '));
            }
        });
    }
    findTabToActivate(hash, target) {
        var _a;
        if (target) {
            return this.findTabFromTarget(target);
        }
        if (hash) {
            return this.findTabByHash(hash);
        }
        return ((_a = this.tabsList) === null || _a === void 0 ? void 0 : _a.querySelector(`[data-id]`)) || null;
    }
    findTabFromTarget(target) {
        return target.querySelector('button');
    }
    findTabByHash(hash) {
        var _a;
        let tab = (_a = this.tabsList) === null || _a === void 0 ? void 0 : _a.querySelector(`[data-id="${hash}"]`);
        if (!tab) {
            tab = this.findTabByAnchorHash(hash);
        }
        return tab || null;
    }
    findTabByAnchorHash(hash) {
        var _a, _b;
        const anchorElement = (_a = this.tabsElement) === null || _a === void 0 ? void 0 : _a.querySelector(`${this.tabsContentClass} a${hash}`);
        if (!anchorElement) {
            return null;
        }
        const tabPane = anchorElement.closest('.tabs-pane');
        if (!tabPane) {
            return null;
        }
        const tabId = tabPane.getAttribute(this.tabIdAttribute);
        return ((_b = this.tabsList) === null || _b === void 0 ? void 0 : _b.querySelector(`[data-id="#${tabId}"]`)) || null;
    }
    activateTab(tab) {
        if (!tab) {
            return;
        }
        tab.classList.add(...this.tabActiveClass.split(' '));
        this.makeActiveTab(tab);
        const parentElement = tab.parentElement;
        if (parentElement) {
            this.scrollTabsTitleIntoView(parentElement);
        }
    }
    updateArrowsState() {
        if (!this.tabsList || !this.prevArrow || !this.nextArrow) {
            return;
        }
        const tabsListElem = this.tabsList;
        const leftOffset = tabsListElem.scrollLeft;
        const rightOffset = tabsListElem.scrollWidth - (leftOffset + tabsListElem.clientWidth) - 1;
        const hidePrevArrow = leftOffset <= 0;
        const hideNextArrow = rightOffset < 0;
        this.prevArrow.parentElement.classList.toggle('!hidden', hidePrevArrow);
        this.nextArrow.parentElement.classList.toggle('!hidden', hideNextArrow);
    }
    scrollTabList(toRight) {
        if (!this.tabsList) {
            return;
        }
        const scrollAmount = this.tabsList.clientWidth / 2;
        const targetScroll = toRight
            ? this.tabsList.scrollLeft + scrollAmount
            : this.tabsList.scrollLeft - scrollAmount;
        app_1.scrollService.GoToPosition(app_1.ScrollDirectionEnum.Left, targetScroll, 750, this.tabsList);
    }
    updateHash(nextHash) {
        const hash = globalThis.location.hash.toLowerCase();
        if (nextHash !== hash) {
            history.pushState(globalThis.history.state, undefined, nextHash);
        }
    }
    replaceHash(hash) {
        history.replaceState(globalThis.history.state, undefined, hash);
    }
    getTabsListContainerHeight() {
        var _a;
        return ((_a = this.tabsListContainer) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0;
    }
    getPreviousVisibleTabId(tabToSelect) {
        let previousElement = tabToSelect.previousElementSibling;
        while (previousElement) {
            if (previousElement.classList.contains('tabs-pane') &&
                !previousElement.classList.contains('hidden-tab')) {
                return previousElement.getAttribute(this.tabIdAttribute);
            }
            previousElement = previousElement.previousElementSibling;
        }
        return '';
    }
    initialTabSelection() {
        var _a;
        const hash = globalThis.location.hash.toLowerCase();
        const firstTabElement = (_a = this.tabsList) === null || _a === void 0 ? void 0 : _a.querySelector('[data-id]');
        const firstTabsHash = firstTabElement ? firstTabElement === null || firstTabElement === void 0 ? void 0 : firstTabElement.dataset.id : '';
        if (globalThis.scrollY === 0 && hash !== firstTabsHash) {
            setTimeout(() => {
                this.highlightSelectedTab(hash);
                this.updateArrowsState();
                this.selectTab(hash);
                this.scrollTabsByAnchorHashPosition(hash);
                this.initiated = true;
            }, INITIAL_TAB_SELECTION_DELAY);
        }
        else {
            this.highlightSelectedTab(hash);
            this.updateArrowsState();
            this.initiated = true;
        }
    }
    updateVerticalGutter() {
        if ((0, app_1.isMobile)()) {
            this.verticalGutter = SCROLL_MOBILE_GUTTER;
        }
        else {
            this.verticalGutter = SCROLL_DESKTOP_GUTTER;
        }
    }
}
exports.TabsComponent = TabsComponent;
exports.tabsComponent = new TabsComponent();
